
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pencarian-populer",
      function () {
        return require("private-next-pages/pencarian-populer/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pencarian-populer"])
      });
    }
  